import { onlineWords } from './miss_category.js';
// Plain words for system text on staff pages (Kimi's UI assessment, Rod 2026-10-13 "1 a", change 7): a row, a call note or a timeline line
// can carry the claims system's own words (a phone-system error with its JSON, a filing gate code, "duplicate guard lookup failed"). Staff
// see plain words; the raw text stays in the row's hover for engineers. Display only: the counts, the categories and the emails are not
// touched (miss_category.ts is a shared contract with the controller and keeps its text).
const REVIEW_WHY = [
    [/carrier account type is subrogation compan(?:y|ies)/i, 'the carrier on file is a subrogation company, not an insurer'],
    [/insurance record has no linked carrier/i, 'the record has no carrier linked'],
    [/carrier is not an insurer(?: \(acord\))?/i, 'the carrier on file is not listed as an insurer'],
];
/** [pattern (global), replacement]: applied in order, each to the output of the one before */
const RULES = [
    // the phone system refused the number: drop the vendor name and the JSON error body after it
    [/Retell refused the carrier phone number before the call(?:\s*\(\d{3}[^]*)?/gi, () => "the phone system refused the carrier's number before the call"],
    [/duplicate guard lookup failed: another call on this insurance record was still in progress after the \d+-minute wait/gi,
        () => 'another call on this record was still running, so this one stopped'],
    [/duplicate guard lookup failed[^.;()]*?(?=\s*[(.;]|$)/gi, () => 'the check for a call already running could not finish, so the call stopped'],
    [/carrier requires human review: ([^.;]+)/gi, (_m, why) => {
            const hit = REVIEW_WHY.find(([re]) => re.test(why));
            return `a person checks the carrier first: ${hit ? hit[1] : why.trim()}`;
        }],
    // a bare filing code (GATE_TARGET_MISSING, ANSWER_POLICY_NUMBER_SHAPE, SKIPPED_GATE_...) becomes the filing lane's own plain words
    [/\b(?:SKIPPED_)?(?:GATE|ANSWER)_[A-Z0-9_]+\b/g, (code) => onlineWords(code)],
    // any JSON object left inline (an error body) is noise on a staff page
    [/\s*\{\\?"[^]*?\}(?:\\?"\))?/g, () => ''],
];
/** The plain-words form of one line of system text; the same text (trimmed) when nothing matched. */
export function plainWords(s) {
    let out = String(s ?? '').trim();
    for (const [re, to] of RULES)
        out = out.replace(re, to);
    return out.replace(/\s{2,}/g, ' ').trim();
}
/** true when plainWords changed the text (the row then keeps the raw text in its hover) */
export const hasSystemWords = (s) => plainWords(s) !== String(s ?? '').trim();
/** A Queue row's words (Kimi's layout pass 2026-10-13, T4): the plain words above, and any system error they did not cover (an HTTP status,
 *  a JSON body, a CODE_LIKE_THIS, a network error code) becomes one plain sentence. The raw text stays on the Today and Trends pages. */
const RAW_LEFT = /\bHTTP ?\d{3}\b|[{}]|\b[A-Z]{2,}(?:_[A-Z0-9]+)+\b|\b(?:ECONN\w+|ETIMEDOUT|EAI_\w+|ENOTFOUND)\b|\bstatus(?: code)? [45]\d\d\b/;
export const RAW_ERROR_WORDS = 'the call failed; the tech team sees it';
export function queueWords(s) {
    const out = plainWords(s);
    return RAW_LEFT.test(out) ? RAW_ERROR_WORDS : out;
}
//# sourceMappingURL=plain.js.map